import { TDrawerProps } from '@@types/popup';
import { Drawer as ChakraDrawer, DrawerOverlay } from '@chakra-ui/react';
export default function Drawer({
  isOpen,
  children,
  closePopup,
  popupOptions,
}: TDrawerProps) {
  return (
    <ChakraDrawer
      isOpen={isOpen}
      onClose={closePopup}
      size="sm"
      {...popupOptions}
    >
      <DrawerOverlay />
      {children}
    </ChakraDrawer>
  );
}
